import { linear } from "regression";
import { SeriesType } from "./types";
import { esgScores } from "common/esg-helpers";
import { language } from "language/default";
export const getMinMax = (points) => {
    if (points.length <= 0) {
        return [0, 0];
    }
    const startFrom = points[0].dataX;
    const minMax = [startFrom, startFrom];
    points.forEach((point) => {
        if (point.dataX < minMax[0]) {
            minMax[0] = point.dataX;
        }
        if (point.dataX > minMax[1]) {
            minMax[1] = point.dataX;
        }
    });
    return minMax;
};
export const getLineY = (lineX, slope, intercept) => (slope * lineX) + intercept;
export const getLinearRegressionEquation = (points) => {
    const regressionData = linear(points.filter((c) => c.dataX && c.dataY)
        .map((c) => [c.dataX, c.dataY]));
    return regressionData.equation;
};
export const getLineData = (points, displayLinearRegression) => {
    if (!displayLinearRegression) {
        return null;
    }
    const filteredPoints = points.filter((x) => x.dataX !== null && x.dataY !== null);
    const minMax = getMinMax(filteredPoints);
    const [slope, intercept] = getLinearRegressionEquation(filteredPoints);
    return {
        data: !intercept && !slope
            ? []
            : [
                { x: minMax[0], y: getLineY(minMax[0], slope || 0, intercept || 0) },
                { x: minMax[1], y: getLineY(minMax[1], slope || 0, intercept || 0) }
            ],
        intercept,
        name: language.en.chart.scatterPlot.linearRegression,
        showInLegend: true,
        slope,
        type: SeriesType.Line
    };
};
export const getScattersData = (pts, colorSet, haveLinearRegression) => {
    const arr = {};
    let hasColorDimension = false;
    pts.forEach((pt) => {
        if (pt.dataColor) {
            hasColorDimension = true;
            if (!arr[pt.dataColor]) {
                arr[pt.dataColor] = [];
            }
            arr[pt.dataColor].push(pt);
        }
    });
    if (!hasColorDimension) {
        arr[""] = pts;
    }
    const result = Object.entries(arr).map((scoreAndPoints) => ({
        data: scoreAndPoints[1].map((point) => ({ ...point, x: point.dataX, y: point.dataY })),
        name: scoreAndPoints[0],
        showInLegend: pts.some((val) => val?.dataX !== 0 || val?.dataY !== 0) && ((haveLinearRegression && hasColorDimension) || !haveLinearRegression),
        type: SeriesType.Scatter
    }));
    if (colorSet?.toLocaleLowerCase() === "esg") {
        result.sortESG((a) => a.name);
    }
    return [result, hasColorDimension];
};
export const getSeries = (inputSeries, colorSet) => {
    const arr = [];
    inputSeries.forEach((serie) => {
        if (serie.type === SeriesType.Line) {
            arr.push({
                className: "lineElement",
                data: serie.data,
                id: serie.name,
                marker: {
                    enabled: false
                },
                name: serie.name,
                showInLegend: serie.showInLegend,
                type: serie.type,
                zIndex: 0
            });
        }
        else if (serie.type === SeriesType.Scatter) {
            const output = {
                className: "scatterElement",
                data: serie.data.filter((c) => (c.x || c.x === 0) && (c.y || c.y === 0)),
                id: serie.name,
                marker: {
                    symbol: "circle"
                },
                name: serie.name,
                showInLegend: serie.showInLegend,
                type: serie.type,
                zIndex: 1
            };
            if (colorSet?.toLocaleLowerCase() === "esg") {
                output.colorIndex = esgScores.indexOf(serie.name);
            }
            arr.push(output);
        }
    });
    return arr;
};
